import React from "react";
import { useLocation } from "react-router";

// ReactRouter doesn't handle scroll restoration by default.
// The component it exports doesn't work with BrowserRouter.
export function ScrollRestoration(): null {
	const { pathname } = useLocation();

	React.useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return null;
}
